@let isMobile = isMobile$ | async;
@if ((showNavbar.mobile && isMobile) || (showNavbar.desktop && isMobile === false)) {
  <nav class="tw-flex tw-min-h-20 tw-py-4 tw-px-7 tw-items-center tw-justify-between">
    <div class="tw-flex-1">
      <a routerLink="/">
        <img src="/images/letly-logo.svg" alt="Letly" style="height:27px;width:auto">
      </a>
    </div>

    <div class="tw-flex tw-flex-1 tw-justify-center tw-items-center tw-gap-8 tw-typography-body-lg">
      @if (showLinks && isMobile === false) {
        @if (isLandlord()) {
          @for (item of landlordNavItems; let i = $index; track i) {
            <a class="tw-flex tw-flex-col tw-gap-3 tw-text-neutral-400"
               [routerLink]="item.route"
               [ngClass]="{'tw-text-neutral-700': isItemActive(item)}">
              {{ item.name }}
              <div class="tw-w-7 tw-h-1.5px tw-m-auto"
                   [ngClass]="{'active-link-indicator': isItemActive(item)}">
              </div>
            </a>
          }
        } @else {
          @for (item of tenantNavItems; let i = $index; track i) {
            <a class="tw-flex tw-flex-col tw-gap-3 tw-text-neutral-400"
               [routerLink]="item.route"
               routerLinkActive="tw-text-neutral-700"
               #rla="routerLinkActive">
              {{ item.name }}
              <div class="tw-w-7 tw-h-1.5px tw-m-auto"
                   [ngClass]="{'active-link-indicator': rla.isActive}">
              </div>
            </a>
          }
        }
      }
    </div>

    <div class="tw-flex tw-flex-1 tw-justify-end tw-items-center tw-gap-2 tw-relative tw-z-50">
      @if (showAuthActions && isMobile === false) {
      @if (posthogEnabled && (isAuthenticated$ | async) === false) {
        <a
          class="tw-text-sm tw-font-medium tw-text-neutral-500 hover:tw-text-neutral-700 tw-px-3 tw-py-1.5"
          routerLink="/account/privacy">
          Privacy
        </a>
      } @else if (effectiveIsLandlord() || hasProperties() || environment.appMetadata?.['becomeLandlord']) {
        <a
          class="tw-text-sm tw-font-medium hover:tw-bg-primary-50 hover:tw-text-primary-700 tw-px-3 tw-py-1.5 tw-rounded-md"
          (click)="handleRoleSwitch()">
          @if (effectiveIsLandlord()) {
            <ng-container i18n="@@ui-common.navbar.role-switch.to-tenants">Switch to <span class="tw-text-primary-500">tenant</span></ng-container>
          } @else if (hasProperties()) {
            <ng-container i18n="@@ui-common.navbar.role-switch.to-landlord">Switch to <span class="tw-text-primary-500">landlord</span></ng-container>
          } @else {
            <ng-container i18n="@@ui-common.navbar.role-switch.become-landlord">Become a <span class="tw-text-primary-500">landlord</span></ng-container>
          }
        </a>
      }

      <letly-user-profile-dropdown [showPrivacy]="posthogEnabled" (logout)="signOut()"></letly-user-profile-dropdown>
      }
    </div>
  </nav>
}
